export var AcceptanceStatus;
(function (AcceptanceStatus) {
    AcceptanceStatus["AwaitingClosure"] = "awaitingclosure";
    AcceptanceStatus["Closed"] = "closed";
    AcceptanceStatus["Declined"] = "declined";
    AcceptanceStatus["FirstLineApproval"] = "firstlineapproval";
    AcceptanceStatus["Open"] = "open";
    AcceptanceStatus["Pending"] = "pending";
})(AcceptanceStatus || (AcceptanceStatus = {}));
//# sourceMappingURL=acceptance-status.js.map